import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import apiUrl from "../../environment/Api";
import "../../assets/css/Studentinfo.css";

function SinglePageView() {
  const [activeTab, setActiveTab] = useState("profile");
  const [student, setStudent] = useState([]); // Initialize as null
  const [studentBranch, setStudentBranch] = useState(null);
  const [studentinvoice, setstudentinvoice] = useState([]);
  const [paymentDetails, setpaymentDetails] = useState([]);
  const [studentDariry, setStudentDairy] = useState([]);

  const formatDatefitching = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const { id } = useParams();

  useEffect(() => {
    fetchDatas();
    feesdata();
  }, [id]); // Fetch data whenever id changes


const feesdata =  async ()=>{
  try{
  const feesdetails = await axios.get(apiUrl + `/studinginvoice/${id}`)
  setpaymentDetails(feesdetails.data[0].invoice_details)

  }catch(error){

  }
}


  const fetchDatas = async () => {
    try {
      console.log("fetchDatas called");
      console.log("id is: ", id);

      // Fetching student data
      const responseStudent = await axios.get(apiUrl + `/students/${id}`);
      console.log("from the server:", responseStudent.data);
      setStudent(responseStudent.data);

      const responsedairy = await axios.get(
        apiUrl + `/student_dairy/${id}`
      );
      console.log("from the server:", responsedairy.data);
      setStudentDairy(responsedairy.data);
      // Fetching student branch data
      const responseBranch = await axios.get(
        apiUrl + `/get_student_branch/${id}`
      );
      console.log("branch data from the server:", responseBranch.data);
      setStudentBranch(responseBranch.data);

      const response = await axios.get(apiUrl + `/studinginvoice/${id}`);
      console.log(
        "studinginvoice data from the server:",
        response.data[0].father_name
      );
      console.log("studinginvoice data from the server:", response.data);
      setstudentinvoice(response.data[0]?.invoice_details);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  // Log student data whenever it changes
  useEffect(() => {
    if (student) {
      console.log("The student data is: ", student);
    }
  }, [student]);

  return (
    <>
      <div className="marginup">
        {/* Breadcrumbs */}
        <div className="row">
          <div className="col-lg-11">
            <Link to="/dashboard" className="text-secondary dashBoard_text">
              <b>Dashboard / </b>
            </Link>
            <Link
              to="/Studyingstudents"
              className="text-secondary dashBoard_text"
            >
              <b>Studying Students / </b>
            </Link>
            <Link to="" className="text-danger dashBoard_text">
              <b>Profile</b>
            </Link>
          </div>
        </div>

        <h5>
          <b>Student Profile</b>
        </h5>

        {/* Student Details */}
        <div className="row mt-4 mb-4">
          <div className="col-lg-3 col-sm-3 col-md-3">
            <div className="card carddetails  mt-3">
              <div className="imgdetails">
                <img
                  src={`${apiUrl}/uploads/${student.photo_upload || ""}`}
                  alt=""
                  className="img-fluid"
                  style={{
                    height: "210px",
                    width: "100%",
                    padding: '5px',
                    objectFit: "contain",
                  }}
                />
              </div>
            </div>
          </div>

          <div className="col-lg-9 col-md-9 col-sm-12">
            <div className="card p-3" style={{ background: '#9F0000', boxShadow: ' rgba(0, 0, 0, 0.35) 0px 5px 15px ' }} >
              <div className="row">
                <div className="col-lg-6">
                  <div className="row mb-4">
                    {/* <i className="fa-solid fa-user text-secondary me-2"></i> */}
                    <h6 className="text-white pb-1 m-0">Name :</h6>
                    <input
                      className="input_inside text-dark"
                      disabled
                      value={student.student_name_lead || ""}
                      placeholder="No name available"
                      style={{ width: "90%", marginLeft: "10px", background: "white" }}
                    />
                    {/* <b>{student.student_name_lead || ""}</b> */}
                  </div>

                  <div className="row mb-4">
                    {/* <i class="fa-solid fa-phone text-secondary me-2"></i> */}
                    <h6 className="text-white m-0 pb-1">Mobile :</h6>
                    <input
                      className="input_inside text-dark"
                      disabled
                      value={student.mobile_no_lead || ""}
                      placeholder="No name available"
                      style={{ width: "90%", marginLeft: "10px", background: "white" }}
                    />

                    {/* <b>{student.mobile_no_lead || ""}</b> */}
                  </div>

                  <div className="row">
                    {/* <i class="fa-solid fa-id-card text-secondary me-2"></i> */}

                    <h6 className="text-white m-0 pb-1">Roll No :</h6>
                    <input
                      className="input_inside text-dark"
                      disabled
                      value={student.roll_no || ""}
                      placeholder="No name available"
                      style={{ width: "90%", marginLeft: "10px", background: "white" }}
                    />

                    {/* <b>{student.roll_no || ""}</b> */}
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="row mb-4">
                    {/* <i class="fa-solid fa-phone text-secondary me-2"></i> */}
                    <h6 className="text-white m-0 pb-1">Register No :</h6>
                    <input
                      className="input_inside text-dark"
                      disabled
                      value={student.register_no || ""}
                      placeholder="No name available"
                      style={{ width: "90%", marginLeft: "10px", background: "white" }}
                    />

                    {/* <b>{student.register_no || ""}</b> */}
                  </div>

                  <div className="row mb-4">
                    {/* <i class="fa-solid fa-book text-secondary me-2"></i> */}
                    <h6 className="text-white m-0 pb-1">Course :</h6>
                    <input
                      className="input_inside text-dark"
                      disabled
                      value={student.Prefered_course_lead || ""}
                      placeholder="No name available"
                      style={{ width: "90%", marginLeft: "10px", background: "white" }}
                    />

                    {/* <b>{student.Prefered_course_lead || ""}</b> */}
                  </div>

                  <div className="row">
                    {/* <i class="fa-solid fa-phone text-secondary me-2"></i> */}
                    <h6 className="text-white m-0 pb-1">User Id :</h6>
                    <input
                      className="input_inside text-dark"
                      disabled
                      value={student.student_user_id || ""}
                      placeholder="No name available"
                      style={{ width: "90%", marginLeft: "10px", background: "white" }}
                    />

                    {/* <b>{student.student_user_id || ""}</b> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h6 className="">Profile Details</h6>

        <div className="row mb-3">
          <div className="col-lg-9">
            <div className="card p-3 " style={{ boxShadow: '  rgba(0, 0, 0, 0.24) 0px 3px 8px' }}>
              <div className="row">
                <div className="col-lg-6">
                  <div className=" p-2">
                    <div className="row p-1">
                      <div className="col-lg-5 text-secondary">Branch</div>
                      <div className="col-lg-6">
                        <strong>
                          {student.branch_lead?.branch_name || ""}
                        </strong>
                      </div>
                    </div>
                    <div className="row p-1">
                      <div className="col-lg-5 text-secondary">
                        Registration No
                      </div>
                      <div className="col-lg-6">
                        <strong>{student.register_no || ""}</strong>
                      </div>
                    </div>
                    <div className="row p-1">
                      <div className="col-lg-5 text-secondary">Father Name</div>
                      <div className="col-lg-6">
                        <strong>{student.father_name || ""}</strong>
                      </div>
                    </div>
                    <div className="row mt-1 p-1">
                      <div className="col-lg-5 text-secondary">
                        Qualification
                      </div>
                      <div className="col-lg-6">
                        <strong>{student.qualification || ""}</strong>
                      </div>
                    </div>
                    <div className="row mt-1 p-1">
                      <div className="col-lg-5 text-secondary">Category</div>
                      <div className="col-lg-6">
                        <strong>{student.category || ""}</strong>
                      </div>
                    </div>
                    <div className="row mt-1 p-1">
                      <div className="col-lg-5 text-secondary">
                        Batch Timings
                      </div>
                      <div className="col-lg-6">
                        <strong>{student.batch_timings || ""}</strong>
                      </div>
                    </div>
                    <div className="row mt-1 p-1">
                      <div className="col-lg-5 text-secondary">
                        Admission Date
                      </div>
                      <div className="col-lg-6">
                        <strong>
                          {student.admission_date
                            ? new Date(
                              student.admission_date
                            ).toLocaleDateString("en-CA")
                            : ""}
                        </strong>
                      </div>
                    </div>
                    <div className="row p-1">
                      <div className="col-lg-5 text-secondary">
                        Date of Birth
                      </div>
                      <div className="col-lg-6">
                        <strong>
                          {student.date_of_birth
                            ? new Date(
                              student.date_of_birth
                            ).toLocaleDateString("en-CA")
                            : ""}
                        </strong>
                      </div>
                    </div>

                    <div className="row p-1">
                      <div className="col-lg-5 text-secondary">
                        Enquiry Date
                      </div>
                      <div className="col-lg-6">
                        <strong>
                          {student.Enquiry_date_lead
                            ? new Date(student.Enquiry_date_lead).toLocaleDateString("en-CA")
                            : ""}

                        </strong>
                      </div>
                    </div>
                    <div className="row p-1">
                      <div className="col-lg-5 text-secondary">Email</div>
                      <div className="col-lg-6">
                        <strong>{student.email_lead || ""}</strong>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="row mt-1 p-1">
                    <div className="col-lg-5 text-secondary">
                      Enquiry Purpose
                    </div>
                    <div className="col-lg-6">
                      <strong>{student.purpose_enquiry_lead || ""}</strong>
                    </div>
                  </div>

                  <div className="row mt-1 p-1">
                    <div className="col-lg-5 text-secondary">Source Type</div>
                    <div className="col-lg-6">
                      <strong>{student.Source_type_lead || ""}</strong>
                    </div>
                  </div>

                  <div className="row mt-1 p-1">
                    <div className="col-lg-5 text-secondary">Trainer</div>
                    <div className="col-lg-6">
                      <strong>{student.trainer || ""}</strong>
                    </div>
                  </div>

                  <div className="row mt-1 p-1">
                    <div className="col-lg-5 text-secondary">Placements</div>
                    <div className="col-lg-6">
                      <strong>{student.placement || ""}</strong>
                    </div>
                  </div>

                  {/* /\/\/\/\//\/\/\/\/\/\/\/\/\/\/ */}

                  <div className="row mt-1 p-1">
                    <div className="col-lg-5 text-secondary">Total Fees</div>
                    <div className="col-lg-6">
                      <strong>{student.fees || ""}</strong>
                    </div>
                  </div>

                  <div className="row mt-1 p-1">
                    <div className="col-lg-5 text-secondary">Paid</div>
                    <div className="col-lg-6">
                      <strong>{student.fees || ""}</strong>
                    </div>
                  </div>

                  {/* <div className="row mt-1 p-1">
                    <div className="col-lg-5 text-secondary">Total Fees</div>
                    <div className="col-lg-6">
                      <strong>
                        {studentinvoice[0]?.nettotal}
                      </strong>
                    </div>
                  </div>

                  <div className="row mt-1 p-1">
                    <div className="col-lg-5 text-secondary">Balance</div>
                    <div className="col-lg-6">
                      <strong>
                        {studentinvoice[0]?.balance}
                      </strong>
                    </div>
                  </div> */}

                  <div className="row mt-1 p-1">
                    <div className="col-lg-5 text-secondary">Discount</div>
                    <div className="col-lg-6">
                      <strong> {student.discount || ""}</strong>
                    </div>
                  </div>

                  {/* <div className="row mt-1 p-1">
                    <div className="col-lg-5 text-secondary">
                      Course Duration
                    </div>
                    <div className="col-lg-6">
                      <strong>{student.duraction_time || "0"}</strong>
                    </div>
                  </div> */}

                  <div className="row mt-1 p-1">
                    <div className="col-lg-5 text-secondary">Duration</div>
                    <div className="col-lg-6">
                      <strong>{student.duraction || ""}</strong>
                    </div>
                  </div>

                  {/* /\/\/\/\//\/\/\/\/\/\/\/\/\/\/ */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3">
            {/* <h6 className="">Id Proof</h6> */}
            <div className="card carddetails  mb-3">
              <div className="imgdetails">
                <img
                  src={`${apiUrl}/uploads/${student.id_proof || ""}`}
                  alt=""
                  className="img-fluid"
                  style={{
                    height: "200px",
                    width: "100%",
                    objectFit: "cover",
                    padding: '5px'
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <h6 className="">Fees Details</h6>
        <div className="row mb-5">
          <div className="card cardborder p-3 " style={{ marginLeft: '15px', width: '97%' }}>
            <table className="table table-striped responsive">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Branch</th>
                  <th>Date </th>
                  <th>Paid</th>
                  <th>Pay Type</th>
                  <th>Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {paymentDetails.map((item, index) => (
                  <>
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.branch_name}</td>
                      <td>{formatDatefitching(item.date)}</td>
                     
                      <td>{item.paid}</td>
                      <td>{item.paytype}</td>
                      <td>{item.nettotal}</td>
                      <td></td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <h6 className="">Timeline Details</h6>

        <div className="row mb-5">
          <div className="card cardborder p-3 " style={{ marginLeft: '15px', width: '97%' }}>
            <table className="table table-striped responsive">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Date </th>
                  <th>Login</th>
                  <th>logOut</th>
                  <th>Topic</th>
                  <th>Sub Topic</th>
                </tr>
              </thead>
              <tbody>
                {studentDariry.map((item, index) => (
                  <>
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{formatDatefitching(item.date)}</td>
                      <td>{item.login}</td>

                      <td>{item.logout}</td>
                      <td>{item.topic_covered}</td>
                      <td>{item.subtopic}</td>
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default SinglePageView;
